import illustrator from "../assets/skillsImg/illustrator.svg";
import javaScript from "../assets/skillsImg/javascript.svg";
import jQuery from "../assets/skillsImg/jquery.svg";
import react from "../assets/skillsImg/react.svg";
import java from "../assets/skillsImg/java.svg";
import spring from "../assets/skillsImg/spring.svg";
import myBatis from "../assets/skillsImg/mybatis.svg";
import figma from "../assets/skillsImg/figma.svg";
import xd from "../assets/skillsImg/xd.svg";
import photoshop from "../assets/skillsImg/photoshop.svg";
import jira from "../assets/skillsImg/jira.svg";
import git from "../assets/skillsImg/git.svg";
import gitHub from "../assets/skillsImg/github.svg";
import notion from "../assets/skillsImg/notion.svg";
import sass from "../assets/skillsImg/sass.svg";
import bootstrap from "../assets/skillsImg/bootstrap.svg";

export const frontendSkills = [
  { name: "React", img: react },
  { name: "JavaScript", img: javaScript },
  { name: "jQuery", img: jQuery },
  { name: "Bootstrap", img: bootstrap },
  { name: "Sass", img: sass },
];

export const serverSkills = [
  { name: "Java", img: java },
  { name: "Spring", img: spring },
  { name: "MyBatis", img: myBatis },
];

export const designSkills = [
  { name: "Figma", img: figma },
  { name: "XD", img: xd },
  { name: "Photoshop", img: photoshop },
  { name: "Illustrator", img: illustrator },
];

export const collaborationSkills = [
  { name: "Git", img: git },
  { name: "GitHub", img: gitHub },
  { name: "Notion", img: notion },
  { name: "Jira", img: jira },
];
